import {
    GETKYCCONFIGURATIONLIST_SUCCESS,
    GETKYCCONFIGURATIONLIST_FAILED,
    RESET_GETKYCCONFIGURATIONLIST,
    LOADING_GETKYCCONFIGURATIONLIST,
    NETWORK_ERROR_GETKYCCONFIGURATIONLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKycConfigurationList = () => {
    return { type: RESET_GETKYCCONFIGURATIONLIST };
};

const getKycConfigurationList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETKYCCONFIGURATIONLIST });
        await partnerServices
            .post("getKycConfigurationList", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getKycConfigurationListSuccess(res.data));
                        break;
                    default:
                        dispatch(getKycConfigurationListFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETKYCCONFIGURATIONLIST,
                    payload: err,
                });
            });
    };
function getKycConfigurationListSuccess(data) {
    return {
        type: GETKYCCONFIGURATIONLIST_SUCCESS,
        payload: data,
    };
}
function getKycConfigurationListFailed(data) {
    return {
        type: GETKYCCONFIGURATIONLIST_FAILED,
        payload: data,
    };
}

export { resetGetKycConfigurationList, getKycConfigurationList };
